import {gsap} from 'gsap';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const mm = gsap.matchMedia();
      mm.add( '(max-width: 1023px)', () => {
        $( '.scroll-list-card' ).each( function( key, component ) {
          const splide = new Splide( $( component ).find( '.splide--scroll-list-card' )[0], {
            pagination: false,
            arrows: true,
            gap: '32px',
            perPage: 1,
          } );

          splide.mount();
        } );
      } );

      mm.add( '(min-width: 1024px)', () => {
        $( '.scroll-list-card' ).each( function( key, component ) {
          const $panels = $( '.scroll-list-card__list li' );

          // if ( !window.hasMotion ) {
          //   $panels.eq( 0 ).addClass( 'is-active' );
          //   return;
          // }

          let topOffset = $( '.navbar' ).outerHeight();
          const fake = $( component ).find( '.fake' );

          const count = $panels.length;
          let lastIndex = -1;
          const panelHeight = $( component ).find( '.scroll-list-card__card' ).outerHeight();
          const pinnedAmount = panelHeight * count;

          if ( $( '#wpadminbar' ).length ) {
            topOffset += $( '#wpadminbar' ).outerHeight();
          }

          topOffset += parseInt( $( component ).css( 'padding-top' ) );

          const pinner = gsap.timeline( {
            scrollTrigger: {
              trigger: $( component ).find( '.scroll-list-card__inner' )[0],
              pin: true,
              start: 'top ' + topOffset,
              end: '+=' + pinnedAmount,
              onUpdate: function( e ) {
                const adjustedProgress = e.progress;
                let index = Math.floor( adjustedProgress * count );
                if ( index >= count ) index = count - 1;

                if ( index === lastIndex ) return;

                $panels.removeClass( 'is-active' );
                $panels.eq( index ).addClass( 'is-active' );
                lastIndex = index;
              },
              scrub: 1,
            },
          } );

          let totalDelay = 0;
          $( component ).find( '.scroll-list-card__image' ).each( function( key, image ) {
            const next = $( image ).next()[0];
            const delay = ( key * 0.5 );

            if ( window.hasMotion ) {
              if ( key !== $panels.length - 1 ) {
                pinner.to( image, {y: '-100%', ease: 'linear', delay: delay, duration: 0.5}, 0 );
              }

              if ( next ) {
                pinner.to( next, {scale: '1', ease: 'linear', delay: delay, duration: 0.5}, 0 );
              }
            } else {
              if ( key !== $panels.length - 1 ) {
                pinner.to( image, {opacity: 0, ease: 'linear', delay: delay, duration: 0.5}, 0 );
              }
            }

            totalDelay += 0.5;
          } );

          const step = pinnedAmount / ( count - 1 );

          $( component ).find( '.scroll-list-card__link' ).on( 'click', function() {
            const pinStart = $( component ).offset().top - ( topOffset - ( $( '#wpadminbar' ).length ? $( '#wpadminbar' ).outerHeight() : 0 ) ) + 8;
            const index = $( this ).parent().index();
            const scrollAmount = pinStart + ( index * step );

            $( 'html, body' ).animate( {
              scrollTop: scrollAmount,
            }, 1000 );
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'scroll-list-card', COMPONENT );
} )( app );
